import React, { useState, useEffect, useRef } from "react";
import Footer from "./Footer/Footer";
import Routepage from "./Routepage";
import Header from "./Header/Header";
import styles from "./navpages.module.css";
import { publicRequest, sendEmail } from "../requestMethod";
import { message } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { Trans, useTranslation } from "react-i18next";
import BlogPage from "../pages/Blog/BlogPage";
import BlogDetailsPage from "../pages/Blog/BlogDetailsPage";
import { Route } from "react-router-dom";

function Navpages() {
	const { t } = useTranslation();
	const [popUp1, setPopUp1] = useState(false);
	const [banner1, setBanner1] = useState(false);
	const [banner2, setBanner2] = useState(false);
	const recaptcha = useRef(null);
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		email: "",
		subject: process.env.REACT_APP_GUEST_LIST_EMAIL_SUBJECT,
		sendEmail: process.env.REACT_APP_GUEST_LIST_EMAIL,
		munich: false,
		hamburg: false,
	});
	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData((prev) => ({ 
			...prev, 
			[name]: type === 'checkbox' ? checked : value 
		}));
	};

	const handleSubmit = async () => {
		if (!formData.email) return alert(t("banner1.enterEmail"));
		if (!formData.munich && !formData.hamburg) return alert(t("banner1.locationRequired"));
		
		try {
			// Skip captcha validation if no site key is configured
			if (!process.env.REACT_APP_SITE_KEY) {
				// make form submission without captcha
				await sendEmail
					.post("/users/sendGuestListEmail", JSON.stringify(formData))
					.then(() => {
						message.success(
							"Success! You're officially on the guestlist! Keep an eye on your email for all the exciting details coming your way soon.."
						);
						setBanner1(false);
						setBanner2(false);
					})
					.catch((err) => {
						const errorMessage =
							err.response?.data?.message || "An error occurred";
						message.error(errorMessage);
					});
				return;
			}

			const captchaValue = recaptcha.current.getValue();
			if (!captchaValue) {
				alert("Please verify the reCAPTCHA!");
			} else {
				const res = await publicRequest.post("/verify", { captchaValue });
				if (res?.data?.success) {
					// make form submission
					await sendEmail
						.post("/users/sendGuestListEmail", JSON.stringify(formData))
						.then(() => {
							message.success(
								"Success! You're officially on the guestlist! Keep an eye on your email for all the exciting details coming your way soon.."
							);
							setBanner1(false);
							setBanner2(false);
						})
						.catch((err) => {
							const errorMessage =
								err.response?.data?.message || "An error occurred";
							message.error(errorMessage);
						});
					// alert("Form submission successful!");
				} else {
					alert("reCAPTCHA validation failed!");
				}
			}
		} catch (error) {
			console.error("Error submitting form:", error);
			alert("An error occurred. Please try again.");
		}
	};
	const handlePopUp = () => {
		setPopUp1((prev) => !prev);
	};
	const handleBanner1 = () => {
		setBanner1((prev) => !prev);
	};

	const handleBanner2 = () => {
		handleBanner1();
		setBanner2((prev) => !prev);
	};
	const handleBanner2State = () => {
		setBanner2((prev) => !prev);
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			handlePopUp();
		}, 10000);

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			const url = window.location.href;
			if (!url.includes("register")) {
				handleBanner1();
			}
		}, 2000);

		return () => clearTimeout(timer);
	}, []);
	return (
		<div className={styles.container}>
			<Header />
			<Routepage />
			<Footer />

			{banner1 && (
				<div className={styles.popUp1Container}>
					<div className={styles.bannerBox}>
						<p className={styles.closeBanner1} onClick={handleBanner1}>
							X
						</p>
						<img
							className={styles.bannerImg}
							src={t("banner1.popUp")}
							alt="none"
							onClick={handleBanner2State}
						/>
					</div>
				</div>
			)}

			{banner2 && (
				<div className={styles.popUp1Container}>
					<div className={styles.banner2}>
						<p className={styles.close} onClick={handleBanner2}>
							{t("banner1.close")}
						</p>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								flexWrap: "wrap",
								alignItems: "center",
								justifyContent: "center",
								marginBottom: "10px",
							}}>
							<p className="font-inter text-base md:text-4xl text-white text-center max-w-[90%] font-bold mb-3 md:mb-10">
								{t("banner1.banner2Text")}
							</p>
							<p className="font-inter font-normal text-xs md:text-2xl text-white mb-0">
								{t("banner1.banner2SubText")}
							</p>
							<p className="font-inter font-semibold text-xs md:text-2xl text-white mb-3 md:mb-10">
								{t("banner1.banner2SubTextBold")}
							</p>
							<p className="font-inter font-normal text-xs md:text-2xl text-center text-white mb-3">
								<Trans
									i18nKey="banner1.bannerText"
									components={{
										highlight: (
											<span className="font-bold" />
										),
									}}
								/>
							</p>
							<p className="font-inter font-normal text-xs md:text-2xl text-center text-white mb-4 md:mb-8">
								<Trans
									i18nKey="banner1.bannerText2"
									components={{
										highlight: (
											<span className="font-bold" />
										),
									}}
								/>
							</p>
              <p className="font-inter font-normal italic text-xs md:text-lg text-white text-center mb-3 md:mb-10">
								{t("banner1.spoiler")}
							</p>
              <p className="font-inter font-notmal text-xs md:text-2xl text-center text-white mb-0 md:mb-10">
								{t("banner1.spoilerBottom")}
							</p>
							<div className={styles.banner2inputBox}>
								<input
									className={styles.banner2input}
									name="firstName"
									value={formData.firstName}
									onChange={handleChange}
									placeholder={t("banner1.firstNamePlaceholder")}
								/>
								<input
									className={styles.banner2input}
									name="lastName"
									value={formData.lastName}
									onChange={handleChange}
									placeholder={t("banner1.lastNamePlaceholder")}
								/>
							</div>
							<input
								className={styles.banner2Input}
								name="email"
								value={formData.email}
								onChange={handleChange}
								placeholder={t("banner1.emailPlaceholder")}
							/>
							
							{/* Location Checkboxes */}
							<div className={styles.locationCheckboxes}>
								<p className="font-inter font-normal text-xs md:text-xl text-white mb-4">
									{t("banner1.locationLabel")}
								</p>
								<div className={styles.checkboxContainer}>
									<label className={styles.checkboxLabel}>
										<input
											type="checkbox"
											name="munich"
											checked={formData.munich}
											onChange={handleChange}
											className={styles.checkbox}
										/>
										<span className={styles.checkmark}></span>
										<span className={styles.checkboxText}>{t("banner1.location")}</span>
									</label>
									<label className={styles.checkboxLabel}>
										<input
											type="checkbox"
											name="hamburg"
											checked={formData.hamburg}
											onChange={handleChange}
											className={styles.checkbox}
										/>
										<span className={styles.checkmark}></span>
										<span className={styles.checkboxText}>{t("banner1.location2")}</span>
									</label>
								</div>
							</div>
							{process.env.REACT_APP_SITE_KEY && (
								<div
									className={styles.recaptcha_btn}
									style={{ transform: "scale(0.85)", transformOrigin: "0 0" }}>
									<ReCAPTCHA
										ref={recaptcha}
										sitekey={process.env.REACT_APP_SITE_KEY}
									/>
								</div>
							)}
							{/* <ul className={styles.list}>
								{t("banner1.list", { returnObjects: true }).map(
									(item, index) => (
										<li key={index}>{item}</li>
									)
								)}
							</ul> */}
							<button onClick={handleSubmit} className={styles.banner2btn}>
								{t("banner1.getOnTheListButton")}
							</button>
						</div>
						{/* <p className={styles.banner2FooterText}>
							{t("banner1.footerText")}
						</p> */}
					</div>
				</div>
			)}
		</div>
	);
}

export default Navpages;
